module.exports = __webpack_public_path__ + "images/gx11x5.fe30.png";